<template>
    <p class="mb-0">
        <span :class="['main-text', 'small-main-text']">
            {{ formatPercentage(offer.rep_apr.formatted) }}
        </span>

        <span class="small-text d-flex align-self-start">
            {{ $t('results.comparisonRate') }}
            <i class="icon-question-mark d-flex" v-if="tooltipOptions.content" v-tippy="tooltipOptions"></i>
        </span>
    </p>
</template>

<script>
import { formatPercentage } from '@js/utilities/number.js'

export default {
    data() {
        return {
            tooltipOptions: {
                content: this.$t('results.offerBlocks.aprToolTips.comparisonRate'),
                trigger: 'click',
                arrow: true,
            },
        }
    },
    inject: ['offer'],
    methods: {
        formatPercentage: formatPercentage,
    },
}
</script>
